<ul class="feature-list"><li *ngFor="let item of items"><fa-icon class="icon" [icon]="fa.checkCircle"></fa-icon>&nbsp;
{{item}}</li></ul>